import { Component, ElementRef, OnInit, inject, signal, viewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService, GameService, InternationalizationService, SessionService, User, UtilitiesService } from '@app/core/services';
import { DialogConfig } from '@app/shared/game-error/game-error.component';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { TermsConditionsComponent } from '../terms-conditions/terms-conditions.component';
import { AvatarCarouselComponent } from '../avatar-carousel/avatar-carousel.component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./user-details.component.scss'],
    animations: [
        fadeInOnEnterAnimation(),
        fadeOutOnLeaveAnimation(),
    ],
    imports: [AvatarCarouselComponent, FormsModule]
})
export class UserDetailsComponent implements OnInit {
  public avatar = viewChildren<ElementRef>('avatar');

  public username: string;
  public fadeInDuration: number;
  public fadeOutDuration: number;
  public avatarSelected = signal<string>('');

  private profiles: User[];
  public profileExists: boolean;
  public usernamePlaceholder: string;
  public agreeTerms: boolean;

  private router = inject(Router);
  private sessionService = inject(SessionService);
  private utilitiesService = inject(UtilitiesService);
  private gameService = inject(GameService);
  public i18n = inject(InternationalizationService);
  public dialogService = inject(DialogService);

  ngOnInit(): void {
    this.agreeTerms = false;
    this.usernamePlaceholder = this.i18n.str('challengeu.user_what_first_name','What is your first name?')();
    this.profileExists = false;
    this.profiles = this.sessionService.getProfilesHistory();
    this.fadeInDuration = 1000;
    this.fadeOutDuration = 1000;
  }

  confirmSelection(ev: MouseEvent) {
    ev.preventDefault();
    this.profileExists = false;
    if(!this.username || !this.agreeTerms) {
      return;
    }

    const user: User = {
      id: this.utilitiesService.getHash(new Date().getTime().toString() + this.username),
      username: this.username,
      avatar: this.avatarSelected(),
      lastGamePlayed: null,
      highestScore: null,
      activeGame: null
    };

    const location = this.sessionService.getLocation();
    const profileExists = this.profiles.filter(profile => 
      profile.username === user.username && 
      profile.location.country.countryId === location.country.countryId
    );

    if(profileExists.length > 0) {
      this.profileExists = true;
      return;
    }

    this.sessionService.setUser(user, true);
    this.gameService.setGameId(null);

    this.router.navigate(['/main-menu']);
  }

  public showTermsAndConditions(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    const config: DialogConfig = {};
    this.dialogService.open(TermsConditionsComponent, config);
  }

  public toggleAgreeTerms(event: Event) {
    event.preventDefault();
    this.agreeTerms = !this.agreeTerms;
  }
}
